import React, {useState} from 'react';
import {Backdrop, Box, Fade, Modal} from "@mui/material";
import BlueButton from "./BlueButton/BlueButton.js";
import {word} from "../word.js";
import {useParams} from "react-router-dom";
import Api from "../Api.js";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 600 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '97vh'
};
function DeleteManCompany({open,setOpen,setData,org,url}) {
    const params = useParams()
    const {id} = params;
    const deleteAccountant = async () => {
        try {
            const list = [...org.accountant];
            let newAccountantList = list.filter((el) => el.url !== url);
            const urlArray = Object.values(newAccountantList).map(l => l.url);
            const data = org;
            const company = {
                name: data.name,
                client: data.client.url,
                subscribe: data.subscribe,
                accountant: urlArray,
                HVHH: data.HVHH,
                address: data.address,
                url: data.url
            };
            if (list.length > 0) {
                await Api.updateCompanies(id,company)
                const {data} = await Api.companySingle(id)
                setData(data)
            }
        }catch (e) {
            console.log(e)
        }
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className='employee-name-cont d-flex w-100 justify-content-center'>
                        <div className="delete-company">
                            <div className="delete-company-title">Ջնջե՞լ</div>
                            <div className="delete-commpany-button justify-content-between">
                                <BlueButton
                                    disabled={org.is_deleted_by_manager}
                                    title={word.yes}
                                    onChangeValue={() => {
                                        deleteAccountant();
                                        setOpen(false);
                                    }}
                                />
                                <BlueButton
                                    disabled={org.is_deleted_by_manager}
                                    title={word.no}
                                    onChangeValue={() => setOpen(false)}
                                />
                            </div>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default DeleteManCompany;